module.exports = __webpack_public_path__ + "img/discord_bot_icon.7a453336.png";